import React, { FunctionComponent } from "react";

import { bemClassNames, createQA, transformKeysToParamCase } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { AccessibilityProps, QAProps } from "@multiweb/types/react";
import { IconColor, IconSize, IconThemeVariant, SpeakProperty } from "./IconEnums";

export type IconProps = {
    /** Kód určující, která ikona se zobrazí. */
    iconCode: IconCode;
    /** Popisek pro bližší vysvětlení ikony, který se zobrazí po najetí kurzoru. */
    title?: string;
    disabled?: boolean;
    size?: IconSize | number;
    /** Chování při čtení obsahu prohlížečem. Více informací u definice výčtového typu SpeakProperty */
    speak?: SpeakProperty;
    color?: IconColor;
    variant?: IconThemeVariant;
} & QAProps & Pick<AccessibilityProps, "role" | "tabIndex" | "hideOutlineOnFocus" | "ariaChecked" | "ariaDisabled">;

const classNames = bemClassNames("icon-component");

export const Icon: FunctionComponent<IconProps> = ({
    color = IconColor.inherit,
    iconCode,
    disabled = false,
    size = IconSize.small,
    speak = SpeakProperty.none,
    title,
    role,
    qa,
    tabIndex,
    hideOutlineOnFocus,
    ariaChecked,
    ariaDisabled,
    variant = IconThemeVariant.default,
}) => {
    const numericSize: number | undefined = !isNaN(Number(size)) ? size as number : undefined;
    return (
        <span
            style={numericSize ? { fontSize: numericSize } : undefined}
            className={classNames(transformKeysToParamCase({
                color,
                icon: iconCode,
                size: numericSize ? undefined : size,
                speak,
                disabled,
                hideOutlineOnFocus,
                variant,
            }))}
            aria-checked={ariaChecked}
            aria-disabled={ariaDisabled}
            {...{ title, role, tabIndex }}
            {...createQA(qa)}
        />
    );
};
